import React, { forwardRef, useRef, useImperativeHandle } from "react";

import { a, SpringValue } from "@react-spring/web";
import { useAnimateInTrail, IAnimateInProps } from "hooks/useAnimateInTrail";
import { initialOffset } from "components/Animations/SpringProperties/SpringProperties";

interface IOwnSpecificProps {
  animateIn: boolean;
  roles: string[];
}

type IOwnProps = IOwnSpecificProps;

type IProps = IOwnProps;

const WorkDetailsHeroRolesComponent: React.FC<IProps> = ({
  animateIn,
  roles,
  ...props
}) => {
  const [animateInTrail] = useAnimateInTrail(animateIn, roles.length);

  const itemStyles = (index: number) => ({
    opacity: animateInTrail[index].active.to((x) => x),
    transform: animateInTrail[index].active.to(
      (x) => `translateX(calc(${initialOffset(x)}))`
    ),
  });

  return (
    <ul>
      {roles.map((role, index) => (
        <a.li key={index} style={itemStyles(index)}>
          {role}
        </a.li>
      ))}
    </ul>
  );
};

export const WorkDetailsHeroRoles = WorkDetailsHeroRolesComponent;
